import { AuthAdapterInteface } from 'src/adapter/AuthAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';

export class AuthApiClass {
  adapter: AuthAdapterInteface;
  constructor(adapter: AuthAdapterInteface) {
    this.adapter = adapter;
  }
  async getTenantIdByClientCode(client_code: string): Promise<string> {
    try {
      const res = await this.adapter.getTenantIdByClientCode(client_code);
      return res.tenant_id;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getEmailLink(key: string): Promise<string> {
    try {
      const res = await this.adapter.getEmailLink(key);
      return res.email_link;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
